import Axios from "axios";
import { authUrl } from "../../../constants";

const authBaseUrl = `${authUrl}auth`;
const config = {
  headers: { "Content-Type": "application/json-patch+json" }
};

export const refreshTokenApi = {
  refreshToken: () => {
    console.log(`${authBaseUrl}/refresh-token`);
    return Axios.post(
      `${authBaseUrl}/refresh-token`,
      config
    );
  },
};
